import { useQuery, useQueryClient } from 'react-query';
import createCachedSelector from 're-reselect';
import * as api from '../../services/api';
import useOptimisticMutation from '../useOptimisticMutation';
import { QUERY_CACHE_TIME } from '../../constants';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data = {}) => {
    return { account: data };
  }
)({
  keySelector: (_, storeKey) => `${storeKey.join('#')}`
});

const useAccountConfig = ({ onError, getNextPayment } = {}) => {
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['account-config', accountId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchAccountConfig({ accountId, getNextPayment }), {
    select: (accountData) => selector(accountData, storeKey),
    cacheTime: QUERY_CACHE_TIME
  });

  const { account = {} } = data || {};

  const accountStoreKey = ['account', accountId];

  const { mutateAsync: editAccount } = useOptimisticMutation(
    storeKey,
    (accountParams) => api.updateAccountConfig({ accountId, account: accountParams }),
    null,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(accountStoreKey, { exact: true });
        queryClient.invalidateQueries(['accounts']);
        queryClient.invalidateQueries('billing');
        queryClient.invalidateQueries(['branches', accountId]);
      },
      onError: (err) => {
        return onError?.(err);
      }
    }
  );

  return {
    isLoading,
    account,
    editAccount
  };
};

export default useAccountConfig;
